import React, {memo, useMemo, useState} from 'react';
import {useStore} from 'react-redux';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {ROUTES} from '../../configs/routes';
import {ArrowForwardIcon, PlayIcon} from '../../components/SvgComponents/SvgComponents';
import Footer from '../../components/Footer/Footer';
import {t} from '../../services/i18nHandler';
import ModalVideoPlayer from '../../components/Modal/newTemplates/ModalVideoPlayer/ModalVideoPlayer';

function LandingPageIntroSection({language}) {
  const store = useStore().getState();

  const [videoUrl, setVideoUrl] = useState(null);

  const loggedIn = useMemo(() => {
    const rSession = store.rSession || {};
    return rSession.LOGGED_IN;
  }, [store]);

  return (
    <>
      {videoUrl && (
        <ModalVideoPlayer
          onClose={() => setVideoUrl(null)}
          videoSrc={videoUrl}
          text="Видеопрезентация платформы для контактного подбора персонала My new job &reg;"
        />
      )}
      <div className="section section--intro" data-anchor="intro">
        <div className="section--intro--description-text" dangerouslySetInnerHTML={{__html: t('mnj.description')}} />
        <div className="section--intro--background mobile-only" />
        <div className="section--inner">
          <div className="section--container desktop-only">
            <div className="intro-section_wrap">
              <div className="intro-section_content">
                <div className="intro-section_logo">
                  <div className="intro-section_logo_img" />
                  <div className="intro-section_logo_descr" dangerouslySetInnerHTML={{__html: t('mnj.description')}} />
                  <div className="intro-section_logo_slogan">
                    {t('mnj.slogan')}
                  </div>
                </div>
                <div className="intro-section_buttons">
                  <Link
                    to={ROUTES.FEED.route}
                    className="btn btn-base btn-login"
                  >
                    {t('buttons.tryFree')}
                    <ArrowForwardIcon />
                  </Link>
                  {language === 'ru' && (
                    <button
                      type="button"
                      className="watch-video-btn"
                      onClick={() => setVideoUrl('../../assets/files/main-videopresentation.mp4')}
                    >
                      <PlayIcon />
                      {t('buttons.watchVideo')}
                    </button>
                  )}
                </div>
              </div>
              <div className="intro-section_content">
                <div className="intro-section_img" />
              </div>
            </div>
            <div className="mouse-wrap">
              <div className="mouse" />
            </div>
          </div>
          <div className="mobile-only intro-wrapper align-centr flex-column justify-center text-center">
            <div className={`section--intro--logo ${language}`}/>
            <div className="link-bg">
              <Link
                to={ROUTES.FEED.route}
                className="btn btn-base btn-login"
              >
                {t('buttons.tryFree')}
                <ArrowForwardIcon />
              </Link>
            </div>
            {!loggedIn && (
              <>
                <div className="wrapper-item">
                  <Link to={ROUTES.LOGIN.route} className="btn btn-link">{t('buttons.logIn')}</Link>
                </div>
                <div className="wrapper-item">
                  <span>{t('delimeter.or')}</span>
                </div>
                <div className="wrapper-item">
                  <Link to={ROUTES.REGISTRATION.route} className="btn btn-link">{t('buttons.register')}</Link>
                </div>
              </>
            )}
            <div className="mouse-wrap">
              <div className="mouse" />
            </div>
          </div>
        </div>
        <Footer showFooterNav={false} isFull className="only-footer-bottom"/>
      </div>
    </>
  );
}

LandingPageIntroSection.defaultProps = {
  language: 'ru',
};

LandingPageIntroSection.propTypes = {
  language: PropTypes.string,
};

export default memo(LandingPageIntroSection);
